module.exports = __webpack_public_path__ + "static/legacy_bn1@2x-c6a0f2e4e67482f9e392f0ddecf199a9.jpg";